import { render } from "./ContactSlider.vue?vue&type=template&id=4f8b18ba&scoped=true"
import script from "./ContactSlider.vue?vue&type=script&lang=js"
export * from "./ContactSlider.vue?vue&type=script&lang=js"

import "./ContactSlider.vue?vue&type=style&index=0&id=4f8b18ba&scoped=true&lan=scss&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8b18ba"]])

export default __exports__